import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e44e8ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-9" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-12"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "youtube_radio"
}
const _hoisted_7 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Youtube "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Youtube ")
], -1))
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "instagram_radio"
}
const _hoisted_11 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Instagram "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Instagram ")
], -1))
const _hoisted_13 = { class: "col-3" }
const _hoisted_14 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "twitter_radio"
}
const _hoisted_15 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Twitter "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Twitter ")
], -1))
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "facebook"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Facebook "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Facebook")
], -1))
const _hoisted_21 = { class: "col-3 mt-5" }
const _hoisted_22 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "tiktok"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Tiktok "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Media Sosial Tiktok")
], -1))
const _hoisted_25 = { class: "col-3 mt-5" }
const _hoisted_26 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "tiktok"
}
const _hoisted_27 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Linkedin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Media Sosial Linkedin ")
], -1))
const _hoisted_29 = { class: "col-3 mt-5" }
const _hoisted_30 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  for: "review_radio"
}
const _hoisted_31 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Review Apps "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, " Review Apps ")
], -1))
const _hoisted_33 = { class: "col-12 col-md-12" }
const _hoisted_34 = { class: "col-12 col-md-12" }
const _hoisted_35 = { class: "col-12 col-md-12" }
const _hoisted_36 = { class: "col-12 col-md-12" }
const _hoisted_37 = { class: "col-12 col-md-12" }
const _hoisted_38 = { class: "col-12 col-md-12" }
const _hoisted_39 = { class: "col-12 col-md-12" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-meh-blank fs-2x text-primary" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Netral")
], -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "col-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-grin-squint text-success fs-2x" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Senang")
], -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "col-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-flushed text-warning fs-2x" })
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Takut")
], -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "col-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-sad-tear text-complete fs-2x" })
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Sedih")
], -1))
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = { class: "col-2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-angry text-danger fs-2x" })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "Marah")
], -1))
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-12 col-md-12" }
const _hoisted_64 = { class: "col-12 col-md-12" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = { class: "col-12 col-md-12" }
const _hoisted_69 = { class: "mt-4 d-flex flex-column flex-md-row gap-3 justify-content-between" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Reset Form ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Batal ")
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload fw-2" }, null, -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Simpan Data ")

import { ref, computed, onMounted } from "vue";
import { Field } from "vee-validate";
import type { FormInstance } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { getStreamsDetail } from "@/views/berita/streams";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";

interface Emit {
  (e: "success-input", value: any): void;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["success-input"],
  setup(__props, { emit }: { emit: ({
  (e: "success-input", value: any): void;
}), expose: any, slots: any, attrs: any }) {

const rule_form_ref = ref<FormInstance>();
const router = useRouter();
const route = useRoute();

const id = ref(route.params.id || "");
const is_loading = ref({
  submit_form: false,
})
const form = ref<any>({
  id_origin: "",
  id_account: "",
  platform: "",
  app_name: "",
  app_id: "",
  url: "",
  account: "",
  date: "",
  emotion: "",
  score: null,
  sentiment: "",
  content: "",
  engagement_detail: {
    like: null,
  },
  input_source: "",
  data_source: "",
  source: "review",
  followers: 0,
});

const media_options = ref<any>({
  application: [],
});

const disabled_name = computed(() => {
  return route.name !== "berita-edit-medsos" && !form.value.platform;
});


const disabled_global = computed(() => {
  return route.name !== "berita-edit-medsos" && !form.value.app_name;
});

const validateScore = (rule, value, callback) => {
  if (value === null || value === 0) {
    callback(new Error("Score wajib diisi"));
  } else {
    callback();
  }
};

const handleRateChange = () => {
  rule_form_ref.value.validateField("score");
};

// FUNCTION
function selectApps(data: any) {
  form.value.app_name = data.app_name;
  form.value.app_id = data.app_id;
}

function setEmotion(value: any) {
  if (value == form.value.emotion) {
    form.value.emotion = "";
  } else {
    form.value.emotion = value;
  }
}

function convertText() {
  if (form.value["content"] != null) {
    let text = form.value.content.split("\n\n");
    let newText = "";

    for (let i = 0; i < text.length; i++) {
      let perTextArray = text[i].split("\n");
      for (let j = 0; j < perTextArray.length; j++) {
        if (perTextArray[j].charAt(perTextArray[j].length - 1) == "-") {
          newText += perTextArray[j].replace(/-/g, "");
        } else {
          newText += perTextArray[j] + " ";
        }
      }
      newText += "\n";
    }
    form.value.content = newText;
  }
}

function resetForm(formEl: FormInstance | undefined) {
  if (!formEl) return; // ✅ pastikan ada
  formEl.resetFields()
}

function submitForm(formEl: FormInstance | undefined) {
  if (!formEl) {
    Swal.fire({
      position: "top-end",
      icon: "error",
      toast: true,
      title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
      showConfirmButton: false,
      timer: 3000,
    });
  } else {
    formEl.validate((valid) => {
      if (valid) {
        is_loading.value.submit_form = true;
        saveData(form.value);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
    });
  }
}

function saveData (data: any) {
  data.date = moment(data.date).format("YYYY-MM-DD HH:mm:ss");
  data.id_account = data.account?.toString()
  .trim()  
  .toLowerCase()
  .replace(/\s+/g, '-')
  .replace(/[^\w\-]+/g, '')
  .replace(/\-\-+/g, '-');
  data.data_source = data.platform;
  data.input_source = data.platform;
  data.sentiment = data.score === 1 || data.score === 2
    ? "-1"
    : data.score === 3
    ? "0"
    : data.score === 4 || data.score === 5
    ? "1"
    : "";

  let params = route.name !== "berita-edit-medsos" ? {
    data: [data],
  } : data;

  const url = route.name !== "berita-edit-medsos" ? "/streams/save-socmed" : `/streams/update-socmed/${id.value}`;

  ApiService.post(url, { data: params })
    .then((response) => {
      if (response.status == 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          toast: true,
          title: "Berhasil! Berita berhasil disimpan",
          showConfirmButton: false,
          timer: 3000,
        });
        
        if (route.name !== "berita-edit-medsos") {
          const id = response.data.inserted_id.split(",");
          emit("success-input", id);
        } else {
          router.go(-1)
        }

        resetForm(rule_form_ref.value)
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: "Gagal! Berita gagal disimpan",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    })
    .catch((error) => {
      Swal.fire({
        position: "top-end",
        icon: "error",
        toast: true,
        title: "Gagal! Berita gagal disimpan",
        showConfirmButton: false,
        timer: 3000,
      });
    })
    .finally(() => {
      is_loading.value.submit_form = false;
    });
};

function getReviewApps(search) {
  const params = {
    ...( form.value.platform ? { platform: form.value.platform } : {}),
    ...( search ? { key: search } : {}),
  };

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  ApiService.get(`/options/review-apps?${query}`)
    .then((response) => {
      media_options.value.application = response.data.review_apps;
    })
    .catch((error) => {
      media_options.value.application = []
    });
};

async function getData() {
  const data_detail = await getStreamsDetail(id.value);
  form.value = {
    id_origin: data_detail.id_origin,
    id_account: data_detail.id_account,
    platform: data_detail.platform,
    app_name: data_detail.app_name,
    app_id: data_detail.app_id,
    url: data_detail.url,
    account: data_detail.account,
    date: data_detail.date,
    emotion: data_detail.emotion,
    score: data_detail.score || 0,
    sentiment: data_detail.sentiment,
    content: data_detail.content,
    engagement_detail: {
      like: data_detail.engagement_detail.like || 0,
    },
    input_source: data_detail.input_source,
    data_source: data_detail.data_source,
    source: data_detail.source,
    followers: data_detail.followers,
  }
}

onMounted(() => {
  setCurrentPageBreadcrumbs("Input Berita", ["Berita"]);
  
  getReviewApps("");
  
  if (route.name == "berita-edit-medsos") {
    getData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: form.value,
    ref: (_value, _refs) => {
      _refs['rule_form_ref'] = _value
      rule_form_ref.value = _value
    },
    "label-position": "left",
    "label-width": "180px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(route).name === 'berita-edit-medsos')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_form_item, {
                  label: "Sumber Berita",
                  prop: "source",
                  rules: {
              required: true,
              message: 'Sumber Berita Wajib Diisi',
              trigger: ['blur', 'change'],
            }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "youtube",
                          id: "youtube_radio",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc007.svg" })
                          ]),
                          _hoisted_8
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "instagram",
                          id: "instagram_radio",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc005.svg" })
                          ]),
                          _hoisted_12
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "twitter",
                          id: "twitter_radio",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc006.svg" })
                          ]),
                          _hoisted_16
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "facebook",
                          id: "facebook",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc004.svg" })
                          ]),
                          _hoisted_20
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "tiktok",
                          id: "tiktok",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc008.svg" })
                          ]),
                          _hoisted_24
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "linkedin",
                          id: "linkedin",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/linkedin.svg" })
                          ]),
                          _hoisted_28
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_unref(Field), {
                          type: "radio",
                          class: "btn-check",
                          name: "source",
                          value: "review",
                          id: "review_radio",
                          modelValue: form.value.source,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.source) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/social/soc002.svg" })
                          ]),
                          _hoisted_32
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_el_form_item, {
              label: "Platform",
              prop: "platform",
              rules: {
              required: true,
              message: 'Platform Wajib Diisi',
              trigger: ['blur', 'change'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-control-custom",
                  modelValue: form.value.platform,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.platform) = $event)),
                  filterable: "",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (getReviewApps('')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Play Store",
                      value: "playstore"
                    }),
                    _createVNode(_component_el_option, {
                      label: "App Store",
                      value: "appstore"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_el_form_item, {
              label: "Nama Aplikasi",
              prop: "app_name",
              rules: {
              required: true,
              message: 'Nama Aplikasi Wajib Diisi',
              trigger: ['blur', 'change'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-control-custom",
                  modelValue: form.value.app_name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.app_name) = $event)),
                  filterable: "",
                  "value-key": "app_name",
                  remote: true,
                  "remote-method": getReviewApps,
                  disabled: _unref(disabled_name),
                  onChange: selectApps
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(media_options.value.application, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item._id,
                        label: item.app_name,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_el_form_item, {
              label: "URL",
              prop: "url",
              rules: [
              { required: true, message: 'URL Wajib Diisi', trigger: ['blur', 'change'] },
              { type: 'url', message: 'Format URL tidak valid', trigger: ['blur', 'change'] }
            ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  placeholder: "URL",
                  modelValue: form.value.url,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.url) = $event)),
                  disabled: _unref(disabled_global),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (form.value.url = form.value.url.trim()))
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_el_form_item, {
              label: "Nama Akun",
              prop: "account",
              rules: {
              required: true,
              message: 'Nama Akun Wajib Diisi',
              trigger: ['blur', 'change'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  placeholder: "Nama Akun",
                  modelValue: form.value.account,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.account) = $event)),
                  disabled: _unref(disabled_global),
                  onBlur: _cache[13] || (_cache[13] = ($event: any) => (form.value.account = form.value.account.trim()))
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_el_form_item, {
              label: "Tanggal",
              prop: "date",
              rules: {
              required: true,
              message: 'Tanggal Wajib Diisi',
              trigger: ['blur'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  style: {"width":"100% !important"},
                  modelValue: form.value.date,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.date) = $event)),
                  placeholder: "Tanggal",
                  format: "YYYY-MM-DD HH:mm:ss",
                  name: "date",
                  type: "datetime",
                  disabled: _unref(disabled_global)
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_el_form_item, {
              label: "Jumlah Like",
              prop: "engagement_detail.like",
              rules: {
              required: true,
              message: 'Jumlah Like Wajib Diisi',
              trigger: ['blur', 'change'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "number",
                  placeholder: "Jumlah Like",
                  disabled: _unref(disabled_global),
                  modelValue: form.value.engagement_detail.like,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.engagement_detail.like) = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_form_item, {
              label: "Emotion",
              prop: "emotion",
              rules: {
              required: false,
              message: 'Emotion Wajib Diisi',
              trigger: ['blur', 'change'],
            }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_el_button, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_netral",
                      disabled: _unref(disabled_global),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (setEmotion('0')))
                    }, null, 8, ["disabled"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", form.value.emotion == '0' ? 'cek-active' : '']),
                      for: "emotion_netral"
                    }, _hoisted_44, 2)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_el_button, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_senang",
                      disabled: _unref(disabled_global),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (setEmotion('1')))
                    }, null, 8, ["disabled"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", form.value.emotion == '1' ? 'cek-active' : '']),
                      for: "emotion_senang"
                    }, _hoisted_48, 2)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_el_button, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_takut",
                      disabled: _unref(disabled_global),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (setEmotion('2')))
                    }, null, 8, ["disabled"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", form.value.emotion == '2' ? 'cek-active' : '']),
                      for: "emotion_takut"
                    }, _hoisted_52, 2)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_el_button, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_sedih",
                      disabled: _unref(disabled_global),
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (setEmotion('3')))
                    }, null, 8, ["disabled"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", form.value.emotion == '3' ? 'cek-active' : '']),
                      for: "emotion_sedih"
                    }, _hoisted_56, 2)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_el_button, {
                      class: "btn-check",
                      name: "emotion",
                      id: "emotion_marah",
                      disabled: _unref(disabled_global),
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (setEmotion('4')))
                    }, null, 8, ["disabled"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", form.value.emotion == '4' ? 'cek-active' : '']),
                      for: "emotion_marah"
                    }, _hoisted_60, 2)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_ErrorMessage, { name: "emotion" })
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_el_form_item, {
              label: "Score",
              prop: "score",
              rules: {
              required: true,
              message: 'Score Wajib Diisi',
              trigger: ['change', 'blur'],
              validator: validateScore
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_rate, {
                  modelValue: form.value.score,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.score) = $event)),
                  size: "x-large",
                  disabled: _unref(disabled_global),
                  onChange: handleRateChange
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_el_form_item, {
              label: "Konten",
              prop: "content",
              rules: {
              required: true,
              message: 'Konten Wajib Diisi',
              trigger: ['blur'],
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.content,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.content) = $event)),
                  type: "textarea",
                  rows: "10",
                  disabled: _unref(disabled_global),
                  onBlur: _cache[23] || (_cache[23] = ($event: any) => (form.value.content = form.value.content.trim()))
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("a", {
                  size: "small",
                  class: "btn btn-sm btn-primary mt-5",
                  type: "primary",
                  onClick: convertText
                }, _hoisted_67)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", null, [
                (_unref(route).name !== 'berita-edit-medsos')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "w-100 w-md-auto",
                      plain: "",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (resetForm(rule_form_ref.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_70
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "w-100 w-md-auto btn btn-danger",
                      plain: "",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_unref(router).go(-1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_71
                      ]),
                      _: 1
                    }))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (submitForm(rule_form_ref.value))),
                  loading: is_loading.value.submit_form,
                  class: "w-100 w-md-auto",
                  disabled: _unref(disabled_global)
                }, {
                  default: _withCtx(() => [
                    _hoisted_72,
                    _hoisted_73
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})